import { type SVGAttributes, useState } from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '../../lib/utils';

/** Tailwind's `animate-spin` turns once per second. */
const SPIN_PERIOD_MS = 1_000;

export interface SpinnerProps extends SVGAttributes<SVGSVGElement> {
  size?: number;
}

/**
 * Tailwind/lucide replacement for MUI's CircularProgress. Every spinner is
 * phase-locked to the clock, so spinners that mount at different times (rows
 * of a list, say) turn in step instead of each starting from the top.
 */
function Spinner({ className, size = 20, style, ...props }: SpinnerProps) {
  const [phase] = useState(() => Date.now() % SPIN_PERIOD_MS);
  return (
    <Loader2
      className={cn('animate-spin text-current', className)}
      width={size}
      height={size}
      style={{ animationDelay: `-${phase}ms`, ...style }}
      {...props}
    />
  );
}

export { Spinner };
